<style>
.slide-fade {
  animation: fade-in 1s;
}

.slide-fade.show {
  animation: fade-in 19s;
}

.slide-fade.hide {
  animation: fade-out 15s;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.table th,
.table td {
  padding: 0.4rem;
}
.invoice-table tfoot tr td {
  font-size: 1erm;
}
</style>
<template>
  <!-------------------- END - Controles arriba de tabla-------------------->
  <div class="table-response">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Proveedor</th>
          <th>Fechas</th>
          <th>Docto</th>
          <th>T. Gasto/Origen</th>
          <th>Cuenta Contable</th>
          <th class="text-right">Otros Imp.</th>
          <th class="text-right">Iva</th>
          <th class="text-right">Valor</th>
        </tr>
      </thead>
      <tbody
        v-for="detalle in current.cargod_set"
        :key="detalle.id"
        @click="abrirModaldetalleFactura(detalle)"
      >
        <tr
          v-bind:class="{
            'table-active': detalle == factura_detalle,
          }"
          class="os-dropdown-position-left"
        >
          <td>
            Ni: {{ detalle.nit }}
            <br />
            Nombre: {{ detalle.nit_nombre }}
          </td>
          <td>
            {{ detalle.fecha_documento }}
            <br />
            F.IVA: {{ detalle.fecha_iva }}
          </td>
          <td>{{ detalle.documento }}</td>
          <td>
            {{ detalle.bien_servicio_str }}
            <br />
            {{ detalle.local_importado_str }}
          </td>
          <td>
            {{ detalle.cuenta_contable.id }}
            <br />
            {{ detalle.cuenta_contable.nombre }}
            <br />
            <span v-if="detalle.centro_costo"
              >C.Cost. {{ detalle.centro_costo.id }} -
              {{ detalle.centro_costo.nombre }}</span
            >
          </td>
          <td class="text-right">Q {{ detalle.valor_otros_impuestos }}</td>
          <td class="text-right">Q {{ detalle.valor_iva }}</td>
          <td class="text-right">Q {{ detalle.valor_total }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="font-weight-bold" colspan="7">
            <h6>Total Detalle Compra</h6>
          </td>
          <td class="text-right font-weight-bold" colspan="2">
            <h6>Q {{ current.total }}</h6>
          </td>
        </tr>
      </tfoot>
      <tfoot v-if="detalle_visible == true">
        <tr class="slide-fade">
          <td colspan="8">
            <table class="table table-striped table-bordered">
              <thead class="table-info">
                <tr>
                  <th>producto</th>
                  <th>Cantidad</th>
                  <th>Precio de linea</th>
                  <th>Fecha creación</th>
                </tr>
              </thead>
              <tbody class="table-info">
                <tr
                  v-for="detalle in factura_detalle.cargodproducto_set"
                  :key="detalle.id"
                >
                  <td>
                    {{ detalle.producto }}
                  </td>
                  <td>
                    {{ detalle.cantidad }}
                  </td>
                  <td>
                    {{ detalle.precio }}
                  </td>
                  <td>
                    {{ current.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tfoot>
    </table>

    <div
      class="onboarding-modal modal fade animated"
      id="onboardingWideFormModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <form class="modal-content" @submit="agregarDetalle">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h4 class="onboarding-title">Agregar Detalle de Compra</h4>
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.nit &&
                          nuevo_detalle.errors.nit.length > 0,
                      }"
                      >Nit:</label
                    >
                    <input
                      v-model="nuevo_detalle.nit"
                      class="form-control"
                      placeholder="Nit"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.nit &&
                          nuevo_detalle.errors.nit.length > 0,
                      }"
                      type="text"
                    />
                    <small
                      v-if="nuevo_detalle.errors && nuevo_detalle.errors.nit"
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.nit[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.nombre_factura &&
                          nuevo_detalle.errors.nombre_factura.length > 0,
                      }"
                      >Nombre Factura:</label
                    >
                    <input
                      v-model="nuevo_detalle.nombre_factura"
                      class="form-control"
                      placeholder="Nombre Factura"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.nombre_factura &&
                          nuevo_detalle.errors.nombre_factura.length > 0,
                      }"
                      type="text"
                    />
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.nombre_factura
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.nombre_factura[0] }}</small
                    >
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.fecha_documento &&
                          nuevo_detalle.errors.fecha_documento.length > 0,
                      }"
                      >Fecha Documento</label
                    >
                    <datepicker
                      :format="'dd/MM/yyyy'"
                      :bootstrap-styling="true"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.fecha_documento &&
                          nuevo_detalle.errors.fecha_documento.length > 0,
                      }"
                      v-model="nuevo_detalle.fecha_documento"
                    ></datepicker>
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.fecha_documento
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.fecha_documento[0] }}</small
                    >
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.documento &&
                          nuevo_detalle.errors.documento.length > 0,
                      }"
                      >Serie-Documento:</label
                    >
                    <input
                      v-model="nuevo_detalle.documento"
                      class="form-control"
                      placeholder="Serie-Documento"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.documento &&
                          nuevo_detalle.errors.documento.length > 0,
                      }"
                      type="text"
                    />
                    <small
                      v-if="
                        nuevo_detalle.errors && nuevo_detalle.errors.documento
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.documento[0] }}</small
                    >
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.valor_total &&
                          nuevo_detalle.errors.valor_total.length > 0,
                      }"
                      >Total</label
                    >
                    <input
                      v-model="nuevo_detalle.valor_total"
                      class="form-control text-right"
                      placeholder="Total"
                      type="text"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.valor_total &&
                          nuevo_detalle.errors.valor_total.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        nuevo_detalle.errors && nuevo_detalle.errors.valor_total
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.valor_total[0] }}</small
                    >
                  </div>
                </div>

                <div class="col-2">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.valor_otros_impuestos &&
                          nuevo_detalle.errors.valor_otros_impuestos.length > 0,
                      }"
                      >Otrs. Imp.</label
                    >
                    <input
                      v-model="nuevo_detalle.valor_otros_impuestos"
                      class="form-control text-right"
                      placeholder="Otrs. Imp."
                      type="text"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.valor_otros_impuestos &&
                          nuevo_detalle.errors.valor_otros_impuestos.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.valor_otros_impuestos
                      "
                      class="form-text text-danger"
                      >{{
                        nuevo_detalle.errors.valor_otros_impuestos[0]
                      }}</small
                    >
                  </div>
                </div>

                <div class="col-2">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.valor_iva &&
                          nuevo_detalle.errors.valor_iva.length > 0,
                      }"
                      >IVA.</label
                    >
                    <input
                      v-model="nuevo_detalle.valor_iva"
                      class="form-control text-right"
                      placeholder="IVA"
                      type="text"
                      v-bind:class="{
                        'is-invalid':
                          nuevo_detalle.errors.valor_iva &&
                          nuevo_detalle.errors.valor_iva.length > 0,
                      }"
                    />
                    <small
                      v-if="
                        nuevo_detalle.errors && nuevo_detalle.errors.valor_iva
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.valor_iva[0] }}</small
                    >
                  </div>
                </div>

                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Origen</label>
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="nuevo_detalle.local_importado"
                    >
                      <option value="L">Local</option>
                      <option value="E">Import</option>
                    </select>
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.local_importado
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.local_importado[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="nuevo_detalle.bien_servicio"
                    >
                      <option value="B">Bien</option>
                      <option value="S">Servicio</option>
                    </select>
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.bien_servicio
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.bien_servicio[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.cuenta_contable &&
                          nuevo_detalle.errors.cuenta_contable.length > 0,
                      }"
                      >Cuenta Contable</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="nuevo_detalle.cuenta_contable"
                    >
                      <option
                        v-for="(c, key) in cuentas_contables"
                        :value="c.id"
                        :key="key"
                      >
                        <span v-for="x in c.id.length - 1" :key="x"
                          >&nbsp;</span
                        >
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="
                        nuevo_detalle.errors &&
                        nuevo_detalle.errors.cuenta_contable
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.cuenta_contable[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          nuevo_detalle.errors.centro_costo &&
                          nuevo_detalle.errors.centro_costo.length > 0,
                      }"
                      >Centro de Costo</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="nuevo_detalle.centro_costo"
                    >
                      <option
                        v-for="(c, key) in centros_costos"
                        :value="c.id"
                        :key="key"
                      >
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="
                        nuevo_detalle.errors.centro_costo &&
                        nuevo_detalle.errors.centro_costo.length > 0
                      "
                      class="form-text text-danger"
                      >{{ nuevo_detalle.errors.centro_costo[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Guardar</button>
              <button
                class="btn btn-secondary"
                data-dismiss="modal"
                type="button"
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modaldetalleFactura"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modaldetalleFactura"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="invoice-table">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>producto</th>
                    <th>Cantidad</th>
                    <th>Precio de linea</th>
                    <th>Fecha creación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detalle in factura_detalle.cargodproducto_set"
                    :key="detalle.id"
                  >
                    <td>
                      {{ detalle.producto }}
                    </td>
                    <td>
                      {{ detalle.cantidad }}
                    </td>
                    <td>
                      {{ detalle.precio }}
                    </td>
                    <td>
                      {{
                        current.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import SubirFacturaScanModalComponentVue from "../../wms/recepcion/SubirFacturaScanModalComponent.vue";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      data: [],
      detalle_visible: "",
      factura_detalle: "",
      cuentas_contables: [],
      centros_costos: [],
      nuevo_detalle: {
        id: null,
        centro_costo: null,
        cuenta_contable: null,
        fecha_creacion: null,
        fecha_documento: null,
        nit: null,
        nombre_factura: null,
        documento: null,
        bien_servicio: "B",
        local_importado: "L",
        valor_total: null,
        valor_iva: null,
        valor_otros_impuestos: null,
        observaciones: null,
        cargo_e: null,
        errors: {
          id: null,
          bien_servicio_str: null,
          local_importado_str: null,
          centro_costo: null,
          cuenta_contable: null,
          fecha_creacion: null,
          fecha_documento: null,
          nit: null,
          nombre_factura: null,
          documento: null,
          bien_servicio: null,
          local_importado: null,
          valor_total: null,
          valor_iva: null,
          valor_otros_impuestos: null,
          observaciones: null,
          cargo_e: null,
        },
      },
    };
  },
  computed: {},
  props: ["current"],
  mounted() {
    let self = this;
    self.refreshCuentasContables();
    self.refreshCentroCosto();
  },
  methods: {
    abrirModaldetalleFactura(detalle) {
      if (this.detalle_visible == true) {
        this.detalle_visible = false;
        this.factura_detalle = "";
      } else {
        this.detalle_visible = true;
        this.factura_detalle = detalle;
      }
    },
    refreshCuentasContables() {
      let self = this;
      DynamicService.fetch("conta", "cuenta-contable", {
        listado_simple: true,
      }).then((res) => {
        self.cuentas_contables = res.data;
      });
    },
    refreshCentroCosto() {
      let self = this;
      DynamicService.fetch("cat", "centro-costo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.centros_costos = res.data;
      });
    },
    agregarDetalle(e) {
      let self = this;
      e.preventDefault();

      let params = self.nuevo_detalle;
      if (params.fecha_documento) {
        params.fecha_documento = moment(params.fecha_documento).format(
          "DD/MM/YYYY"
        );
      }
      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current.id,
        "agregar_detalle",
        params
      )
        .then((res) => {
          self.$emit("refresh");
          self.nuevo_detalle = {
            id: null,
            centro_costo: null,
            cuenta_contable: null,
            fecha_creacion: null,
            fecha_documento: null,
            nit: null,
            nombre_factura: null,
            documento: null,
            bien_servicio: "B",
            local_importado: "L",
            valor_total: null,
            valor_iva: null,
            valor_otros_impuestos: null,
            observaciones: null,
            cargo_e: null,
            errors: {
              id: null,
              bien_servicio_str: null,
              local_importado_str: null,
              centro_costo: null,
              cuenta_contable: null,
              fecha_creacion: null,
              fecha_documento: null,
              nit: null,
              nombre_factura: null,
              documento: null,
              bien_servicio: null,
              local_importado: null,
              valor_total: null,
              valor_iva: null,
              valor_otros_impuestos: null,
              observaciones: null,
              cargo_e: null,
            },
          };
        })
        .catch((error) => {
          console.log(error.response.data);
          self.nuevo_detalle.errors = error.response.data;
          self.$emit("refresh");
        });
    },
  },
};
</script>
